<template>
  <el-row class="coal-block">
    <el-row>
      <el-col :span="1"><el-row class="zy-icon-double-control" /></el-col>
      <el-col :span="4">
        <el-row class="screen-title">能耗双控</el-row>
        <el-row class="title-underline"/>
      </el-col>
    </el-row>
    <el-row style="align-items: center;" :style="getDiffStyle(0)">
      <el-col class="left-border-title screen-title">单位产值综合能耗（kgce/万元）</el-col>
    </el-row>
    <el-row class="energy-chart-box1" :style="getDiffStyle(-2)">
      <common-charts :index="'_coal_rank1'" :options="tendCurve1"
                     :style="getDiffStyle(5)" :key="timeStamp"/>
    </el-row>
    <el-row style="align-items: center;width: calc(100% - 20px)" :style="getDiffStyle(-1)">
      <el-col span="12" class="left-border-title screen-title">综合能耗总量（kgce）</el-col>
      <el-col span="12" class="right-border-title screen-title">产值（万元）</el-col>
    </el-row>
    <el-row class="energy-chart-box2" :style="getDiffStyle(0)">
      <common-charts :index="'_coal_rank2'" :options="tendCurve2"
                     :style="getDiffStyle(6)" :key="timeStamp"/>
    </el-row>
  </el-row>
</template>

<script>
import buildCoalLineConfig from "../../../config/chart/config_coal_line_ext";
import buildCoalBarConfig from "../../../config/chart/config_coal_bar";
import CommonCharts from "../../common/chart/CommonCharts";

export default {
  name: "EnergyBlock",
  components: {CommonCharts},
  data() {
    return {
      initOptions: {
        renderer: 'canvas'
      },
      tendCurve1: {},
      tendCurve2: {},
      tendCurve3: {},
      timeStamp: 0,
      coalUnit: 'kg'
    }
  },
  props: ["isFull", "coalData"],
  created() {
    this.setData(null);
  },
  watch: {
    coalData: function (newV, oldV) {
      if(oldV !== newV) this.setData();
    }
  },
  methods: {
    getDiffStyle(type, i = -1) {
      if(type === -2) return this.isFull ? 'margin-top: 24px;' : 'margin-top: 18px;'
      if(type === -1) return this.isFull ? 'margin-top: 46px;' : 'margin-top: 40px;'
      if(type === 0) return this.isFull ? 'margin-top: 16px;' : 'margin-top: 12px;'
      if(type === 1) return this.isFull ? 'font-size: 54px;' : 'font-size: 48px;'
      if(type === 2) return this.isFull ? 'margin-top: 14px;' : 'margin-top: 8px;'
      if(type === 3) return this.isFull ? 'margin-top: 28px;' : 'margin-top: 24px;'
      if(type === 4 && i === -1) return this.isFull ? 'height: 112px;' : 'height: 106px;'
      if(type === 4 && i === 0) return this.isFull ? 'height: 80px;width: 80px;border: 3px dashed #488CFF;' : 'height: 106px;width: 106px;border: 3px dashed #488CFF;'
      if(type === 4 && i === 1) return this.isFull ? 'height: 80px;width: 80px;border: 3px dashed #35FF5B;' : 'height: 106px;width: 106px;border: 3px dashed #35FF5B;'
      if(type === 4 && i === 2) return this.isFull ? 'height: 80px;width: 80px;border: 3px dashed #FFF95B;' : 'height: 106px;width: 106px;border: 3px dashed #FFF95B;'
      if(type === 4 && i === 3) return this.isFull ? 'height: 80px;width: 80px;border: 3px dashed #FF682C;' : 'height: 106px;width: 106px;border: 3px dashed #FF682C;'
      if(type === 5) return this.isFull ? 'height: 160px;' : 'height: 140px;'
      if(type === 6) return this.isFull ? 'height: 180px;' : 'height: 150px;'
      if(type === 7) return this.isFull ? 'top: 28px;left: 13px;' : 'top: 40px;left: 27px;'
    },
    getCoal(sourceData, isUnit = false) {
      let resData = parseFloat(sourceData)
      let resUnit = 'kg'
      if(resData) {
        if(sourceData >= 1000000) {
          resData = (sourceData / 10000).toFixed(2)
          resUnit = '万kg'
        }else{
          resData = sourceData
        }
      }
      if(isUnit) return resUnit
      else return resData
    },
    setData() {
      if(this.coalData.dataData1) this.tendCurve1 = buildCoalBarConfig(this.coalData.dataDate1, this.coalData.dataData1)
      if(this.coalData.dataData2) this.tendCurve2 = buildCoalLineConfig(this.coalData.dataDate2, this.coalData.dataData2.split(','), this.coalData.dataData3.split(','))
      this.timeStamp = new Date().getTime()
    }
  }
}
</script>

<style scoped>
.coal-block{
  margin-top: 25px;
  padding: 10px 0 0 20px;
  height: 509px;
  color: #15AEFE;
  background: url("../../../assets/images/digital-screen/coal-bg.png");
  background-size: 100% 100%;
}
.circle-container{
  border-radius: 50%;
  position: absolute;
  overflow: hidden;
}
.zy-icon-double-control {
  width: 24px;
  height: 25px;
  background: url("../../../assets/images/digital-screen/double-control.png") no-repeat;
  background-size: 100% 100%;
}
.energy-chart-box1{
  width: 100%;
  height: 25%;
}
.energy-chart-box2{
  width: 100%;
  height: 25%;
}
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/DigitalScreen/EnergyBlock.vue